import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_ROOT || 'https://wesdasdasda.online/escort_api/';

function getHeaders(user_id) {
    const tg = window.Telegram?.WebApp;
    const initData = tg?.initData || '';
    return {
        'Content-Type': 'application/json',
        'X-User-ID': user_id,
        'X-Telegram-Init-Data': initData,
    };
}

class UserService {
    saveModel(data) {
        return axios.post(BACKEND_URL +'models/save', data, {headers: getHeaders()});
    }

    isWorker(data) {
        return axios.post(BACKEND_URL +'is_worker', data, {headers: getHeaders(data)})
    }

    getAllModels(userId, page = 1, limit = 8, search = '', service_filter = '', max_price = 0) {
        return axios.post(BACKEND_URL + 'models/all', { user_id: userId, page, limit, search, service_filter, max_price }, {headers: getHeaders(userId)})
    }

    getModel(model_id, user_id) {
        return axios.get(BACKEND_URL +'models/' + model_id + '/' + user_id,  {headers: getHeaders(user_id)})
    }

    deleteModel(model_id, user_id) {
        return axios.delete(BACKEND_URL +'models/' + model_id + '/' + user_id, {headers: getHeaders()})
    }

    createComment(data) {
        return axios.post(BACKEND_URL +'models/create_comment', data, {headers: getHeaders()})
    }

    getComments(model_id) {
        return axios.get(BACKEND_URL +'models/get_comments/' + model_id + '/1', {headers: getHeaders()})
    }

    delComm(comm_id, user_id) {
        return axios.delete(BACKEND_URL +'models/del_com/' + comm_id + '/' + user_id, {headers: getHeaders()})
    }

    getSimpleModel(model_id, user_id) {
        return axios.get(BACKEND_URL +'models/simple/' + model_id + '/' + user_id, {headers: getHeaders(user_id)})
    }

    uploadCheck(data) {
        return axios.post(BACKEND_URL +'models/upload_check', data, {headers: getHeaders()})
    }

    getAdmins() {
        return axios.get(BACKEND_URL +'models/admins', {headers: getHeaders()})
    }

    getPromo(user_id) {
        return axios.get(BACKEND_URL +'models/get_promo/' + user_id + '/', {headers: getHeaders()})
    }

    createPromo(data) {
        return axios.post(BACKEND_URL +'models/save_promo', data, {headers: getHeaders()})
    }

    deletePromo(promo) {
        return axios.delete(BACKEND_URL +'models/delete_promo/' + promo + '/1', {headers: getHeaders()})
    }

    findPromo(promo) {
        return axios.get(BACKEND_URL +'models/find_promo/' + promo, {headers: getHeaders()})
    }

    getPayment(user_id) {
        return axios.get(BACKEND_URL +'models/get_card/', {headers: getHeaders(user_id)})
    }

    getUsers(user_id) {
        return axios.get(BACKEND_URL +'models/get_users/' + user_id + '/', {headers: getHeaders()})
    }

    createUser(data) {
        return axios.post(BACKEND_URL +'models/create_user', data, {headers: getHeaders()})
    }

    deleteUser(user_id) {
        return axios.delete(BACKEND_URL +'models/delete_user/' + user_id + '/', {headers: getHeaders()})
    }

    sendMessages(data) {
        return axios.post(BACKEND_URL +'models/send_to_users', data, {headers: getHeaders()})
    }

    getCountry(user_id) {
        return axios.get(BACKEND_URL +'models/get_country/' + user_id+ '/', {headers: getHeaders()})
    }

    getRegion(user_id) {
        return axios.get(BACKEND_URL +'models/get_region/' + user_id+ '/', {headers: getHeaders()})
    }

    update_country(user_id, region) {
        return axios.get(BACKEND_URL +'models/update_country/' + user_id + '/' + region, {headers: getHeaders()})
    }

    getRuCard() {
        return axios.get(BACKEND_URL +'models/get_ru_card', {headers:getHeaders()})
    }

    getKzCard() {
        return axios.get(BACKEND_URL +'models/get_kz_card', {headers:getHeaders()})
    }

    // Worker sheet methods
    getWorkerSettings(userId) {
        return axios.get(BACKEND_URL + 'workers/settings', { headers: getHeaders(userId) })
    }

    updateWorkerSettings(userId, data) {
        return axios.post(BACKEND_URL + 'workers/update_settings', data, { headers: getHeaders(userId) })
    }

    getMirrors(userId) {
        return axios.get(BACKEND_URL + 'workers/mirrors', { headers: getHeaders(userId) })
    }

    getRefs(userId) {
        return axios.get(BACKEND_URL + 'workers/refs', { headers: getHeaders(userId) })
    }

    createRef(userId, data) {
        return axios.post(BACKEND_URL + 'workers/refs/create', data, { headers: getHeaders(userId) })
    }

    deleteRef(userId, uid) {
        return axios.delete(BACKEND_URL + 'workers/refs/' + uid, { headers: getHeaders(userId) })
    }

    getCustomization(userId, workerUid) {
        return axios.get(BACKEND_URL + 'workers/customization?worker_uid=' + workerUid, { headers: getHeaders(userId) })
    }

    saveCustomization(userId, data) {
        return axios.post(BACKEND_URL + 'workers/customization/save', data, { headers: getHeaders(userId) })
    }

    uploadStartImage(userId, data) {
        return axios.post(BACKEND_URL + 'workers/customization/upload_image', data, { headers: getHeaders(userId) })
    }

    deleteStartImage(userId, uid) {
        return axios.delete(BACKEND_URL + 'workers/customization/delete_image/' + uid, { headers: getHeaders(userId) })
    }

    // Crypto payment methods
    getPaymentSettings(userId) {
        return axios.get(BACKEND_URL + 'models/payment_settings', { headers: getHeaders(userId) })
    }

    createCryptoInvoice(userId, data) {
        return axios.post(BACKEND_URL + 'models/create_crypto_invoice', data, { headers: getHeaders(userId) })
    }

    cryptoInvoiceStatus(userId, invoiceId) {
        return axios.get(BACKEND_URL + 'models/crypto_invoice_status/' + invoiceId, { headers: getHeaders(userId) })
    }

    getUsdtAddress(userId) {
        return axios.get(BACKEND_URL + 'models/usdt_address', { headers: getHeaders(userId) })
    }

    verifyUsdtTx(userId, data) {
        return axios.post(BACKEND_URL + 'models/verify_usdt_tx', data, { headers: getHeaders(userId) })
    }
}

export default new UserService();
